import Oidc from 'oidc-client';
import logger from '../Utils/logger';
import redirectHelper from './redirectHelper';

/**
 * Module to act as a wrapper around the oidc-token-manager.
 */
function TokenManager() {

  const self = this;
  let userManager = null;
  let user = null;

  self.initAsync = tokenManagerSettings => {

    userManager = new Oidc.UserManager(tokenManagerSettings);

    return userManager.getUser()
      .then(theUser => {
        user = theUser;
      })
      .catch(function (err) {
        console.error(err);
      });
  };

  self.validTokenExists = () => {
    return !!user && !user.expired;
  };

  self.getAccessToken = () => {

    if (!userManager) {
      throw new Error('An attempt was made to retrieve the access token before the token manager has been initialized');
    }

    return user.access_token;
  };

  self.loginRedirect = function () {

    userManager.signinRedirect()
      .then(() => {
        console.log('signinRedirect done');
      })
      .catch(err => {
        logger.logAndThrowUntranslatedError(
          'An error occurred loading the site. Please try again later.',
          'Unable to use the token manager to redirect to the authentication page. ',
          err);
      });
  };

  self.logoutRedirect = function () {
    userManager.signoutRedirect()
      .then(resp => {
        console.log('signed out', resp);
      })
      .catch(err => {
        console.log(err);
      });
  };

  /**
   * When we have a token in the URL after authentication for access to the portal is complete, pass the
   * OIDC client the token and redirect to the main portal page.
   */
  self.processLoginTokenAfterCallback = function () {
    new Oidc.UserManager().signinRedirectCallback()
      .then(user => {
        console.log('Processed the authentication token correctly. Redirecting to the main portal.', user);
        redirectHelper.postPortalAuthenticationRedirect();
      });
  };

  /**
   * When we have a token in the URL after authentication for access to the registration page is complete,
   * pass the OIDC client the token and redirect to the main registration page.
   */
  self.processRegistrationTokenAfterCallback = function () {
    new Oidc.UserManager().signinRedirectCallback()
      .then(user => {
        console.log('Processed the authentication token correctly. Redirecting to the registration screen.', user);
        redirectHelper.postRegistrationAuthenticationRedirect();
      });
  };

  self.processTokenCallbackSilent = function () {
    console.warn('Silent token renewal is not currently supported');
  };
}

export default new TokenManager();
